module.exports = __webpack_public_path__ + "img/steps_2.ec37b609.png";